module.exports = __webpack_public_path__ + "img/logo.350c50de.svg";